import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ChevronRight } from "lucide-react";

const PageHeader = ({ title, subtitle }) => (
  <section className="relative bg-gradient-to-br from-[#0a2463] via-[#0a2463] to-[#082056] text-white py-20 overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute -top-20 -right-10 w-96 h-96 rounded-full bg-green-500 blur-3xl" />
      <div className="absolute -bottom-20 -left-10 w-96 h-96 rounded-full bg-blue-400 blur-3xl" />
    </div>
    <div className="relative max-w-7xl mx-auto px-6">
      <h1 className="text-4xl md:text-5xl font-black mb-3">{title}</h1>
      {subtitle && <p className="text-slate-200 max-w-2xl">{subtitle}</p>}
      <div className="flex items-center gap-2 mt-5 text-sm text-slate-300">
        <Link to="/" className="flex items-center gap-1 hover:text-green-400 transition-colors">
          <HomeIcon size={14} /> Home
        </Link>
        <ChevronRight size={14} />
        <span className="text-green-400">{title}</span>
      </div>
    </div>
  </section>
);

const SimplePage = ({ title, subtitle, children }) => {
  return (
    <>
      <PageHeader title={title} subtitle={subtitle} />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 prose prose-slate max-w-none">
          {children || (
            <div className="text-center py-12">
              <p className="text-slate-500 text-lg">
                This page is coming soon. Detailed content for <strong>{title}</strong> will be available shortly.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SimplePage;
